export default {
  'userStatus.active': 'Active',
  'userStatus.passivated': 'Passive',
  'userStatus.pending_invitation': 'Pending Invitation',
  'userStatus.status.unknown': 'Unknown',
  'userStatus.verification': 'Verified',
  'userStatus.notVerification': 'Not Verified',
};
